import {usePage} from "@inertiajs/vue3";

export default {
    methods: {
        userCan: function (permission) {
            const user = this.$page?.props?.auth?.user;

            if (!user) {
                return false;
            }

            return user.permissions.includes(permission) || user.admin;
        }
    }
}

export function useUserCan() {
    const page = usePage();

    const userCan = (permission) => {
        const user = page.props?.auth?.user;

        if (!user) {
            return false;
        }

        return user.permissions.includes(permission) || user.admin;
    }

    return {
        userCan,
    }
}
